import { render, staticRenderFns } from "./TagLocaleEditor.vue?vue&type=template&id=5275d136"
import script from "./TagLocaleEditor.vue?vue&type=script&lang=ts"
export * from "./TagLocaleEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports